import { Component } from 'react';
import { css } from '@emotion/react';

import EventUpComing from './EventUpComing';
import * as Breakpoints from '../../../constants/breakpoints';
import * as InternalPropTypes from '../../../constants/internal-types';
import TitleTextGroup from './TitleTextGroup';
import { TypeSEOWeightTypes } from '../../../constants/cms-constants';
import SEOWeights from '../../../constants/cms/control-options/seo-weights';
import { getLowerSEOWeight } from '../../../utils/SEOWeight';

const styles = css({
  '& .event-up-coming': {
    [Breakpoints.TabletDown.mq]: {
      marginTop: '40px',
      marginBottom: '0px',
    },
    [Breakpoints.DesktopUp.mq]: {
      marginTop: '50px',
      marginBottom: '50px',
    },
  },
});

type EventUpComingListProps = {
  events?: InternalPropTypes.Event[];
  mainHeader?: InternalPropTypes.RichText;
  seoWeight?: TypeSEOWeightTypes;
};

class EventUpComingList extends Component<EventUpComingListProps> {
  static defaultProps = {
    events: [],
    mainHeader: '',
    seoWeight: SEOWeights.P,
  };

  render() {
    const { events, mainHeader, seoWeight } = this.props;

    const lowerSEOWeight = getLowerSEOWeight(seoWeight);

    return (
      <div css={styles}>
        {events && (
          <TitleTextGroup titleText={mainHeader} seoWeight={seoWeight} />
        )}

        {events &&
          events.map((event) => (
            <div
              key={`${event.title}-${event.date}`}
              className="event-up-coming"
            >
              <EventUpComing
                title={event.title}
                image={event.image}
                date={event.date}
                geoLocation={event.geoLocation}
                onlineLocation={event.onlineLocation}
                language={event.language}
                seoWeight={lowerSEOWeight}
              />
            </div>
          ))}
      </div>
    );
  }
}

export default EventUpComingList;
